import useEmblaCarousel from 'embla-carousel-react'
import Autoplay from 'embla-carousel-autoplay'

import type { FC } from 'react'
import type { ICmsUserReviews } from '@/pages/tad.ai/_components/FeatureCms/_types'

import LazyImage from '@/components/LazyImage'
import { useLocale } from '@/hooks/routes'
import { usePrevNextButtons } from '@/hooks/carousel'
import { useScreen } from '@/hooks/screen'
import { H2 } from '@/pages/tad.ai/_components/H2'
import { RichTextElement } from '@/pages/tad.ai/_components/RichTextElement/RichTextElement'


import { cls } from 'tagged-classnames-free';
export interface IUserReviewsProps {
  userReviews?: ICmsUserReviews | null
  className?: string
}

export const UserReviews: FC<IUserReviewsProps> = (props) => {
  const { userReviews, className } = props
  const { title, authorList = [] } = userReviews || {}
  const locale = useLocale()
  const isMd = useScreen('md')
  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      loop: true,
      align: 'start',
      dragFree: false,
      direction: locale === 'ar' ? 'rtl' : 'ltr',
    },
    [Autoplay()],
  )
  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi)

  const isCarousel = authorList.length > 3

  const displayList =
    authorList.length >= 6 || isMd ? authorList : [...authorList, ...authorList]

  return (
    <div className={cls`${className}`}>
      <div className='mx-auto w-full max-w-[1380px] text-center'>
        <H2>{title}</H2>
        <div className='mt-12 flex items-center justify-center gap-7 '>
          {isCarousel && (
            <button
              type='button'
              disabled={prevBtnDisabled}
              onClick={onPrevButtonClick}
              className={cls`
                bg-f-bg-disabled text-f-text-secondary 
                 hover:bg-f-primary group
                 hidden size-14 items-center
                 justify-center rounded-full transition-all duration-500 xl:flex
              `}
            >
              <span
                className={cls`${locale === 'ar' ? 'i-com--right' : 'i-com--left'} group-hover:bg-f-text-invert size-8`}
              />
            </button>
          )}

          <div className='flex-1 overflow-hidden' ref={emblaRef}>
            <div className={cls`flex flex-col gap-4 xl:flex-row xl:gap-0`}>
              {displayList.map((item, index) => (
                <div
                  key={`${item.name}-${index}`}
                  className={cls`
                    border-f-border
                    relative me-7 box-border flex w-full
                    shrink-0 flex-col items-start gap-4 rounded-3xl
                    border p-6 xl:w-[calc((100%-2*1.75rem)/3)]
                  `}
                >
                  <div className='flex items-center gap-2'>
                    {Array.from({ length: 5 }, (_, i) => (
                      <span
                        key={`star-${i}`}
                        className='i-com--star-solid text-f-primary size-6 '
                      />
                    ))}
                  </div>
                  <RichTextElement
                    as='div'
                    html={item.desc}
                    className='text-f-other-10 w-full flex-1 text-start'
                  />
                  <div className='flex items-center justify-start gap-2'>
                    <LazyImage
                      src={item.image}
                      width={56}
                      height={56}
                      alt='create-any-video'
                      className='size-14 rounded-full '
                    />
                    <div className='text-start'>
                      <p className='mb-0.5 text-xl font-bold text-white '>
                        {item.name}
                      </p>
                      <p className='text-white'>{item.job}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {isCarousel && (
            <button
              type='button'
              disabled={nextBtnDisabled}
              onClick={onNextButtonClick}
              className={cls`
                bg-f-bg-disabled text-f-text-secondary 
                 hover:bg-f-primary group
                 hidden size-14 items-center justify-center
                 rounded-full transition-all duration-500 
                 xl:flex
              `}
            >
              <span
                className={cls`${locale === 'ar' ? 'i-com--left' : 'i-com--right'} group-hover:bg-f-text-invert size-8`}
              />
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
